import { MutationTree } from 'vuex';
import { GlobalState } from './types';
import Cookies from 'js-cookie'

export function setCartInSession (cart: MerchantCart | null) {
  try {
    if (cart) {
      Cookies.set('CART_ID', cart.id);
    } else {
      Cookies.remove('CART_ID');
    }
  } catch (error) {
    console.log('Cart Save Error', error);
  }
}

export function resetCartInSession () {
  Cookies.remove('CART_ID');
}

export function resetSession () {
  Cookies.remove('SESSION_ID');
}

export const mutations: MutationTree<GlobalState> = {

  toggleHeader(state, status = false): GlobalState {
    state.showHeader = status;
    return state;
  },

  toggleCart(state, status = false): GlobalState {
    state.cartOpen = status;
    return state;
  },

  toggleGlobalLoading (state, status = false): GlobalState {
    state.globalLoading = status;
    return state;
  },

  setCart (state, cart: MerchantCart | null): GlobalState {
    setCartInSession(cart)
    state.cart = cart
    return state;
  },

  setCheckout (state, checkout: Checkout | null): GlobalState {
    state.checkout = checkout
    return state;
  },

  setPaypalDetails (state, paypalData: PaypalData): GlobalState {
    state.paypalData = paypalData
    return state;
  }
};